enum UserEditMode {
    View,
    Create,
    Edit
}

export { UserEditMode };
